'use strict';

var FieldPredictor = require('./predictor');
var ColumnTypeInference = require('./column-type-inference');
module.exports = {
  FieldPredictor: FieldPredictor,
  ColumnTypeInference: ColumnTypeInference
};